(function () {
  'use strict';

  var module = angular.module('uwAgenda.global');
  module.factory('HttpInterceptor', [
    'AppConfig',
    '$q',
    '$rootScope', 
    'CorrelationService',
    HttpInterceptor 
  ]);

  // central http interceptor for exception handling
  // is called every time a http request is made
  function HttpInterceptor(AppConfig, $q, $rootScope, CorrelationService) {
    // count ajax calls
    var activeRequests = 0;
    var activeRequestsTimer = null;
    // ms before activeCalls are being reset automatically, we don't wait for the responses to come in
    var activeRequestsResetTimeout = 10000;      

    var backgroundApiCalls = ['/api/administrations/badges'];
    var callsWithShouldKeepSpinning = ['login','/search', '/subusers/agendas', '/downloads', '/reminders'];
    function isBackgroundApiCall(url) {
      if (!url) {
        return false;
      }

      for (var requestUrl of backgroundApiCalls) {
        if (url.toLowerCase().indexOf(requestUrl) > -1) {
          return true;
        }
      }

      return false;
    }

    function isCallWhichShouldAlwaysKeepSpinning(url) {
      if (!url) {
        return false;
      }

      for (let requestUrl of callsWithShouldKeepSpinning) {
        if (url.toLowerCase().indexOf(requestUrl) > -1) {
          return true;
        }
      }

      return false;
    }

    var incrementActiveRequests = function (url) {
        // start timer with first request
        if (activeRequests === 0) {             
            if (activeRequestsTimer) {
                clearInterval(activeRequestsTimer);                
            }            
            // only add timeout for spinner if it is not a search query
           if (!isCallWhichShouldAlwaysKeepSpinning(url)){
             activeRequestsTimer = setTimeout(resetActiveRequests, activeRequestsResetTimeout);
           }
        }

        activeRequests++; 
        $rootScope.$broadcast('ActiveHttpRequests', {
            activeRequests: activeRequests
          });        
    };

    var decrementActiveRequests = function () {
        activeRequests--;
        if (activeRequests < 0) {
            activeRequests = 0;            
        }        

        $rootScope.$broadcast('ActiveHttpRequests', {
            activeRequests: activeRequests
          });
    };

    var resetActiveRequests = function() {
        activeRequests = 0;
        $rootScope.$broadcast('ActiveHttpRequests', {
            activeRequests: activeRequests
          });        
    }

    return {
      request: function (config) {
        if (config.url && config.url.startsWith('/api')) {
          config.url = AppConfig.ApiUrl + config.url;
          config.headers['X-Correlation-ID'] = CorrelationService.generateCorrelationId();
        }

        if (!isBackgroundApiCall(config.url)) {
          incrementActiveRequests(config.url);
        }
        return config;
      },
      requestError: function (rejection) {
        decrementActiveRequests();
        return rejection;
      },
      response: function (response) {
        if (!isBackgroundApiCall(response.config.url)) {
          decrementActiveRequests();
        }
        return response;
      },
      responseError: function (rejection) {
        decrementActiveRequests();

        let errorObj;
        try {
          if (rejection.data) {
            errorObj = JSON.parse(rejection.data);
          }
        } catch {
          errorObj = rejection.data;
        }

        if (rejection.status === 401) {
          $rootScope.$broadcast('unauthorized');
        } //if
        else {
          $rootScope.$broadcast('response-error', errorObj);
        }
        return $q.reject(errorObj);
      }
    };
  }
})();
